const TableHeader = () => (
  <tr className="tr">
    <th className="th">Mission</th>
    <th className="th">Description</th>
    <th className="th" colSpan="2">Status</th>
  </tr>
);

export default TableHeader;
